
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/validate'
import TitleBox from '@/components/CSS/TitleBox'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import { ossUploadFile } from '@/utils/uploader'
import { debounce } from '@/utils'

export default {
	components: {
		TitleBox
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			defaultAvatar: 'user/defaultAvatar'
			// ossToken: 'ossToken'
		})
	},
	data() {
		var noPhone = (rule, value, callback) => {
			let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
			if (reg.test(value)) {
				callback(new Error('昵称不能使用手机号'))
			} else {
				callback()
			}
		}
		return {
			replaceDia: false,
			ossData: {},
			dialogVisible: false,
			loading: false,
			showCode: true,
			oldShowCode: true,
			smsLoading: false,
			newLoading: false,
			submitDialogLoading: false,
			count: 0,
			counts: 0,
			ruleFrom: {
				headImage: '',
				nickname: '',
				qq: '',
				wxNickname: '',
				wx: '',
				linkPhone: ''
			},
			dialogForm: {
				name: ''
			},
			replaceDiaForm: {
				oldCode: null,
				oldPhone: null,
				phone: null,
				newCode: null
			},
			dialogFules: {
				oldCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				oldPhone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{
						pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}
				],
				newCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{
						pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}
				]
			},
			rules: {
				nickname: [
					{ required: true, message: '请输入您的昵称', trigger: 'blur' },
					{ min: 1, max: 20, message: '长度在1-20个字符', trigger: 'blur' },
					{ validator: noPhone, trigger: 'blur' }
				],
				qq: [
					{
						pattern: /^[1-9]\d{4,10}$/,
						message: '请输入正确的QQ号码',
						trigger: 'blur'
					}
				]
			},
			smsTime: null,
			// start
			cotOutModel: false,
			// 裁剪组件的基础配置option
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 100, // 默认生成截图框宽度
				autoCropHeight: 100, // 默认生成截图框高度
				fixedBox: true, // 固定截图框大小 不允许改变
				fixed: true, // 是否开启截图框宽高固定比例
				fixedNumber: [1, 1], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: false, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				mode: 'cover' //图片默认渲染方式
			},
			UPLOAD_COMMON_TYPE,
			percentage: 0
		}
	},
	methods: {
		// 上传按钮   限制图片大小
		changeUpload(file, fileList) {
			console.log(file, fileList, '文件')
			const isLt5M = file.size / 1024 / 1024 < 5
			if (!isLt5M) {
				this.$message.error('上传文件大小不能超过 5MB!')
				return false
			}
			this.fileinfo = file
			// 上传成功后将图片地址赋值给裁剪框显示图片
			this.$nextTick(() => {
				this.option.img = window.URL.createObjectURL(file.raw)
				this.cotOutModel = true
			})
		},
		// 点击裁剪，这一步是可以拿到处理后的地址
		finish() {
			this.$refs.cropper.getCropBlob(data => {
				this.loading = true
				let _this = this
				ossUploadFile(UPLOAD_COMMON_TYPE.avatar.value, new File([data], this.fileinfo.name, { type: data.type }), {
					ContentType: this.video ? 'video/mp4' : 'image/jpeg',
					progress: (percentage, cpt) => {
						this.percentage = percentage
					}
				}).then(fileData => {
					_this.ruleFrom.headImage = fileData.url
					this.loading = false
					_this.cotOutModel = false
				})
			})
		},
		tipsText() {
			this.$message({
				message: '请在盼之APP、手机网页版进行验证更换',
				type: 'warning'
			})
		},
		closeDia() {
			this.replaceDiaForm = {
				oldCode: null,
				oldPhone: null,
				phone: null,
				smsCode: null
			}
		},
		sendNew() {
			this.newLoading = true

			if (this.replaceDiaForm.phone == null || this.replaceDiaForm.phone == '') {
				this.$message.warning('请输入新手机号')
				this.newLoading = false
				return false
			}

			if (!/^1\d{10}$/.test(this.replaceDiaForm.phone)) {
				this.$message.warning('请输入正确新手机号')
				this.newLoading = false
				return false
			}

			const info = {
				action: {
					phone: this.replaceDiaForm.phone,
					smsTemplate: 'CHECK'
				}
			}
			this.$api.sedSms(info).then(res => {
				this.newLoading = false
				if (res.success) {
					this.$message.success('验证码已发送，请注意查收')
					this.newgetCode()
					this.$refs.codeTwo.focus()
					return false
				} else {
					this.$message.warning(res.info)
				}

				console.log('111', res)
			})
		},
		sendChange() {
			this.smsLoading = true
			if (this.replaceDiaForm.oldPhone == null || this.replaceDiaForm.oldPhone == '') {
				this.$message.warning('请输入旧手机号')
				this.smsLoading = false
				return false
			}

			if (!/^1\d{10}$/.test(this.replaceDiaForm.oldPhone)) {
				this.$message.warning('请输入正确旧手机号')
				this.smsLoading = false
				return false
			}

			//  if (this.replaceDiaForm.oldPhone == null || this.replaceDiaForm.oldPhone == '') {
			//   this.$message.warning("请输入旧手机号");
			//   this.smsLoading = false;
			//   return false;
			// }

			const info = {
				action: {
					phone: this.replaceDiaForm.oldPhone,
					smsTemplate: 'CHECK'
				}
			}
			this.$api.sedSms(info).then(res => {
				this.smsLoading = false
				if (res.success) {
					this.$message.success('验证码已发送，请注意查收')
					this.getCode()
					this.$refs.codeTwo.focus()
					return false
				} else {
					this.$message.warning(res.info)
				}

				console.log('111', res)
			})
		},
		Submit(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let info = {
						action: {
							oldPhone: this.replaceDiaForm.oldPhone,
							oldCode: this.replaceDiaForm.oldCode,
							phone: this.replaceDiaForm.phone,
							smsCode: this.replaceDiaForm.newCode
						}
					}
					this.$api.changePhone(info).then(res => {
						if (!res.success) {
							this.$message.error(res.info)
							this.$refs[formName].resetFields()
							this.replaceDia = false
							return
						}
						console.log(res, '更改手机号')
						this.$message.success('手机号更改成功,请重新登录')
						this.replaceDia = false
						this.$refs[formName].resetFields()
						this.$store.dispatch('user/UserGetInfo')
						this.$router.push('/login')
					})
					// this.replaceDia = false;
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		openReplace: debounce(function () {
			this.$api.checkBlackMeApi().then(res => {
				if (!res.success) return this.$message.error(res.info)
				if (res.data) return this.$message.error('该手机号存在异常行为，暂不支持换绑')
				this.replaceDia = true
			})
		}),
		// 随机生成文件名
		random_string(len) {
			len = len || 32
			let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			let maxPos = chars.length
			let pwd = ''
			for (let i = 0; i < len; i++) {
				pwd += chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return pwd
		},
		getCode() {
			const TIME_COUNT = 60
			if (!this.timer) {
				this.count = TIME_COUNT
				this.showCode = false
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--
					} else {
						this.showCode = true
						clearInterval(this.timer)
						this.timer = null
						this.smsLoading = false
					}
				}, 1000)
			}
		},
		newgetCode() {
			const TIME_COUNT = 60
			if (!this.timers) {
				this.counts = TIME_COUNT
				this.oldShowCode = false
				this.timers = setInterval(() => {
					if (this.counts > 0 && this.counts <= TIME_COUNT) {
						this.counts--
					} else {
						this.oldShowCode = true
						clearInterval(this.timers)
						this.timers = null
						this.newLoading = false
					}
				}, 1000)
			}
		},
		sendSms() {
			this.smsLoading = true
			let data = {
				action: {
					// mobile: this.userinfo.mobile,
					smsTemplate: 'CHECK'
				}
			}
			// this.$store
			//     .dispatch("account/UserSendSms", data)
			this.$api
				.sedSms2(data)
				.then(res => {
					this.smsLoading = false
					if (res.success) {
						this.$message.success('验证码已发送，请注意查收')
						this.getCode()
						this.$refs.code.focus()
						return false
					} else {
						this.$message.warning(res.info)
					}
				})
				.catch(() => {
					this.smsLoading = false
					this.timer = null
				})
		},
		submitDialogForm() {
			this.$api
				.unbindWx({
					action: {
						smsCode: this.dialogForm.code,
						thirdType: 'WECHAT'
					}
				})
				.then(res => {
					if (res.success) {
						this.$store.dispatch('user/UserGetInfo')
						this.dialogVisible = false
						this.$message.success('解绑成功')
					}
				})
		},
		onSubmit() {
			this.$refs['ruleForm'].validate(valid => {
				console.log(valid, '进来了')
				if (valid) {
					this.loading = true
					let p = {
						action: this.ruleFrom
					}
					this.$api
						.modUserInfo(p)
						.then(res => {
							this.loading = false
							if (!res.success) {
								this.$message.error(res.info)
								return
							}
							this.$message.success(res.info)
							this.$store.dispatch('user/UserGetInfo')
							setTimeout(() => {
								this.$router.go(-1)
							}, 1000)
						})
						.catch(() => {
							this.loading = false
						})
				}
			})
		}
	},
	mounted() {
		Object.assign(this.ruleFrom, this.userinfo)
		console.log('this.$route.fullPath', this.$route.fullPath)
	},
	created() {
		// this.$store.dispatch('AppGetOssAuth')
	}
}
